// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"162":"778c9232","247":"43b7565d","358":"06ac4d70","749":"043a9c77","989":"e9cb5547"}[chunkId] + ".chunk.js";
};